import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  allBranchDetail,
  allCounselorDetail,
  allDoctorDetail,
  allDoctorSearchDetail,
  leadCreate,
  patientData,
  patientSearchData,
  searchAllCounselorDetail,
} from '../../../redux/actions/Files.action';
import {
  getAdmin,
  getBranch,
  getCounselor,
  getDoctor,
  searchAdmin,
  searchCounselor,
  searchDoctor,
} from '../../../redux/actions/Master.action';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getSetting, getAllLeadFrom } from '../../../redux/actions/Setting.action';
import { getFormFields } from '../../../redux/actions/Formfields.action';

const AddLead = ({ show, onHide }) => {
  const navigate = useNavigate();
  const limits = 10;
  const [isLoading, setIsLoading] = useState(false);
  const searchDefault1 = { status: '' };
  const [mainPage, setMainPage] = useState(1);
  const dispatch = useDispatch();
  const createFile = useSelector((state) => state.files);
  const masterData = useSelector((state) => state.master);
  const [doctorData, setDoctorData] = useState(false);
  const [doctorData1, setDoctorData1] = useState(false);
  const [doctorData2, setDoctorData2] = useState(false);
  const [SelectedCounselorName, setSelectedCounselorName] = useState('');
  const setting = useSelector((state) => state.setting);
  const formFields = useSelector((state) => state.formFields);
  const leadFrom = setting?.getAllLeadFrom?.data;

  const dropdownRef = useRef(null);
  const createBy = localStorage.getItem('type');
  const [time, setTime] = useState({
    from: '',
    to: '',
  });
  const [values, setValues] = useState({
    firstName: '',//
    middleName: '',//
    lastName: '',//
    gender: '',//
    dateOfBirth: '',//
    city: '',//
    phoneNumber: '',//
    photo: null,//
    branch: '',//
    leadReceived: '',//
    leadStatus: '',//
    leadFrom: '',//
    campaign: { cname: '', description: '' },//
    remark: '',//
    nextFollowUpDate: '',//
    from: '',//
    to: '',//
    counselorAssign: '',//
    leadFollowUpRemark: '',//
    dynamicFields: {}
  });
  const initialValues = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    phoneNumber: Yup.string().required('Phone Number is required'),
  });

  useEffect(() => {
    dispatch(getSetting())
    dispatch(getAllLeadFrom())
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDoctorData(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue('photo', file);
  };

  const handleLead = (e) => {
    const { name, value } = e.target;

    if (name === 'from' || name === 'to') {
      setTime((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      const formattedTime = formatTime12Hour(value);
      setValues((prevState) => ({
        ...prevState,
        [name]: formattedTime,
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };



  const formatTime12Hour = (time) => {
    const [hours, minutes] = time.split(':');
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${minutes} ${period}`;
  };

  const [selectedOption, setSelectedOption] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [selectedCounselor, setSelectedCounselor] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });
  const [searchType, setSearchType] = useState('doctor');

  const selectDoctor = (doctorName, doctorEmail) => {
    setSelectedDoctor(doctorName);
    setDoctorData1(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(allDoctorSearchDetail('', '1'));

    setValues((prevValues) => ({
      ...prevValues,
      doctorName: doctorName,
      doctorEmail: doctorEmail
    }));
  };

  const selectCounselor = (counselorName, counselorId, setFieldValue) => {
    setSelectedCounselor(counselorName);
    setDoctorData2(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(searchAllCounselorDetail({ search: '' }));
    setValues((prevValues) => ({
      ...prevValues,
      counselorAssign: counselorId,
    }));
    setSelectedCounselorName(counselorName);
    setFieldValue('counselorAssign', counselorId);
  };

  const convertToFormData = (values) => {
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      if (key === 'photo' && values[key]) {
        // Append the photo file directly
        formData.append('photo', values[key]);
      } else if (key === 'dynamicFields') {
        // Handle dynamic fields
        Object.entries(values[key]).forEach(([fieldName, fieldValue]) => {
          formData.append(`dynamicFields[${fieldName}]`, fieldValue);
        });
      } else if (Array.isArray(values[key])) {
        formData.append(key, JSON.stringify(values[key]));
      } else if (typeof values[key] === 'object' && values[key] !== null) {
        if (key === 'campaign') {
          formData.append(key, JSON.stringify(values[key]));
        } else {
          Object.keys(values[key]).forEach((innerKey) => {
            formData.append(`${key}.${innerKey}`, values[key][innerKey]);
          });
        }
      } else {
        formData.append(key, values[key]);
      }
    });

    // Debugging: Log FormData entries
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    return formData;
  };


  const handleAddLead = (values, { resetForm }) => {
    setIsLoading(true);
    const formData = convertToFormData({
      ...values,
      dynamicFields: values.dynamicFields || {}
    });

    dispatch(leadCreate(formData, limits, searchDefault1.status))
      .then(() => {
        resetForm();
        onHide();
        navigate('/master/lead');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const searchData = (e) => {
    // const newSearchQuery = ;
    setSearchQuery(e.target.value);
    const newSearchParams = {
      ...searchDefault,
      search: searchQuery || '',
      page: mainPage,
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    // dispatch(searchAdmin(queryParams, newSearchParams.page));

    if (searchType === 'doctor') {
      dispatch(allDoctorSearchDetail(searchQuery))
    } else if (searchType === 'Manager') {

      dispatch(searchAllCounselorDetail(newSearchParams));
    }

    if (searchType === 'Doctor') {
      dispatch(allDoctorSearchDetail(searchQuery));
    } else if (searchType === 'Person') {
      dispatch(patientSearchData(searchQuery));
    }
  };

  useEffect(() => {
    // dispatch(getCounselor(limits));
    dispatch(getAdmin(limits));
    dispatch(allBranchDetail());
    dispatch(allDoctorDetail())
    dispatch(allCounselorDetail())
    dispatch(patientData())
    dispatch(getFormFields())
  }, []);

  const [leadStatuses, setLeadStatuses] = useState([]);
  useEffect(() => {
    dispatch(getSetting());
  }, []);
  // Add this useEffect to fetch lead statuses
  useEffect(() => {
    if (
      setting.getSetting.leadStatuses?.leadStatuses &&
      setting.getSetting.leadStatuses?.leadStatuses?.length > 0
    ) {
      setLeadStatuses(setting.getSetting.leadStatuses?.leadStatuses || []);
    }
  }, [setting]);

  // Add the getBackgroundColor function
  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(
      (status) => status.title.toLowerCase() === leadStatusName.toLowerCase(),
    );
    return status ? status.backgroundColor : 'transparent';
  };

  const handleCancel = () => {
    onHide();
  };

  return (

    <>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        dialogClassName="modal-90w"
        aria-labelledby="add-lead-modal"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title id="add-lead-modal">
            Add Lead
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="container ">
            {isLoading && (
              <div className="loaderAdd">
                <div className="loader_line">
                  <img
                    src={localStorage.getItem('logo')}
                    className="w-[200px]"
                    alt="Loading..."
                  />
                </div>
              </div>
            )}
           


              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleAddLead}
              >
                {({ handleSubmit, setFieldValue, values, errors, handleChange }) => (

                  <Form onSubmit={handleSubmit}>
                    <div className="p-3">
                      <div className="row">
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Branch</Form.Label>
                            <Form.Select
                              placeholder="Select Branch"
                              className="shadow-none focus:!border-theme-dark"
                              name="branch"
                              onChange={(e) => setFieldValue('branch', e.target.value)}
                              value={values.branch}
                            >
                              <option value="" disabled selected>
                                Select Branch
                              </option>{' '}
                              {/* Default placeholder option */}
                              {createFile?.allBranch?.data?.Branches?.map((res) => {
                                return (
                                  <option key={res._id} value={res.branchName}>
                                    {res.branchName}
                                  </option>
                                );
                              })}
                            </Form.Select>
                            <ErrorMessage
                              name="branch"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              name="phoneNumber"
                              as={Form.Control}
                              onChange={(e) =>
                                setFieldValue('phoneNumber', e.target.value)
                              }
                              value={values.phoneNumber}
                              placeholder="Enter Phone Number"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="phoneNumber"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="firstName"
                              as={Form.Control}
                              onChange={(e) =>
                                setFieldValue('firstName', e.target.value)
                              }
                              value={values.firstName}
                              placeholder="Enter First Name"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="firstName"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Middle Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="middleName"
                              as={Form.Control}
                              onChange={(e) =>
                                setFieldValue('middleName', e.target.value)
                              }
                              value={values.middleName}
                              placeholder="Enter Middle Name"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="middleName"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="lastName"
                              as={Form.Control}
                              onChange={(e) =>
                                setFieldValue('lastName', e.target.value)
                              }
                              value={values.lastName}
                              placeholder="Enter Last Name"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="lastName"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        <div className="col-md-3">
                          <Form.Group className="mb-3" controlId="Gender">
                            <Form.Label>Gender</Form.Label>
                            <Form.Select
                              placeholder="Select Gender"
                              className="shadow-none focus:!border-theme-dark"
                              name="gender"
                              onChange={(e) => setFieldValue('gender', e.target.value)}
                              value={values.gender}
                            >
                              <option value="" disabled selected>
                                Select Gender
                              </option>{' '}
                              {/* Default placeholder option */}
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Transander">Transander </option>
                            </Form.Select>
                            {/* <ErrorMessage
                      name="gender"
                      component="div"
                      className="text-danger"
                    /> */}
                          </Form.Group>
                        </div>

                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Date of Birth</Form.Label>
                            <Form.Control
                              type="date"
                              name="dateOfBirth"
                              as={Form.Control}
                              onChange={(e) =>
                                setFieldValue('dateOfBirth', e.target.value)
                              }
                              value={values.dateOfBirth}
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="dateOfBirth"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                              type="text"
                              name="city"
                              as={Form.Control}
                              onChange={(e) => setFieldValue('city', e.target.value)}
                              value={values.city}
                              placeholder="Enter City"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        <div className="col-md-3">
                          <Form.Group className="mb-3" controlId="leadReceived">
                            <Form.Label>Lead Received On</Form.Label>
                            <Form.Select
                              placeholder="Select Lead Received On"
                              className="shadow-none focus:!border-theme-dark"
                              name="leadReceived"
                              onChange={(e) =>
                                setFieldValue('leadReceived', e.target.value)
                              }
                              value={values.leadReceived}
                            >
                              <option value="" disabled selected>
                                Select Lead Received On
                              </option>{' '}
                              {/* Default placeholder option */}
                              <option value="justdialApp">Justdial app</option>
                              <option value="phone">Phone</option>
                              <option value="social">Social</option>
                              <option value="email">Email</option>
                              <option value="whatsapp">Whatsapp</option>
                            </Form.Select>{' '}
                            <ErrorMessage
                              name="leadReceived"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>


                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Lead Status</Form.Label>
                            <Form.Select
                              placeholder="Select Lead Status"
                              className="shadow-none focus:!border-theme-dark"
                              name="leadStatus"
                              onChange={(e) => setFieldValue('leadStatus', e.target.value)}
                              value={values.leadStatus}
                              style={{
                                backgroundColor:
                                  values.leadStatus?.trim()
                                    ? getBackgroundColor(values.leadStatus.trim().toLowerCase())
                                    : '',
                                color: values.leadStatus?.trim() ? 'white' : 'black'
                              }}
                            >
                              <option value="" disabled selected style={{
                                backgroundColor: "lightgray",
                                color: "white"
                              }}>
                                Select Lead Status
                              </option>
                              {setting?.getSetting?.leadStatuses?.leadStatuses?.length > 0
                                ? setting.getSetting.leadStatuses?.leadStatuses?.map((status) => (
                                  <option key={status._id} value={status.title}
                                    style={{
                                      backgroundColor: "white",
                                      color: "black"
                                    }}>
                                    {status.title}
                                  </option>
                                ))
                                : null}
                            </Form.Select>
                            <ErrorMessage
                              name="leadStatus"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Lead From</Form.Label>
                            <div className="d-flex gap-2">
                              <Form.Select
                                name="leadFrom"
                                className="shadow-none focus:!border-theme-dark"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === "manual") {
                                    // Clear the field for manual input
                                    setFieldValue('leadFrom', '');
                                    setSelectedCounselor('');
                                    setSelectedCounselorName('');
                                  } else {
                                    const selectedLeadFrom = leadFrom.find(lead => lead.title === value);
                                    setFieldValue('leadFrom', value);

                                    // Auto-assign counselor if leadAssignTo exists and isAutoAssign is true
                                    if (selectedLeadFrom?.leadAssignTo?._id && selectedLeadFrom.isAutoAssign) {
                                      setFieldValue('counselorAssign', selectedLeadFrom.leadAssignTo._id);
                                      setSelectedCounselorName(selectedLeadFrom.leadAssignTo.name);
                                      setSelectedCounselor(selectedLeadFrom.leadAssignTo.name);
                                    }
                                  }
                                }}
                                value={leadFrom?.some(lead => lead.title === values.leadFrom) ? values.leadFrom : "manual"}
                              >
                                <option value="manual" className='fw-bold bg-light' >Other</option>
                                {leadFrom?.map((lead) => (
                                  <option key={lead._id} value={lead.title}>
                                    {lead.title}
                                  </option>
                                ))}
                              </Form.Select>
                              {(!leadFrom?.some(lead => lead.title === values.leadFrom) || values.leadFrom === '') && (
                                <Form.Control
                                  type="text"
                                  placeholder="Enter Lead From"
                                  className="shadow-none focus:!border-theme-dark"
                                  value={values.leadFrom}
                                  onChange={(e) => {
                                    setFieldValue('leadFrom', e.target.value);
                                    // Clear auto-assigned counselor when manually entering lead from
                                    setSelectedCounselor('');
                                    setSelectedCounselorName('');
                                  }}
                                />
                              )}
                            </div>
                            <ErrorMessage
                              name="leadFrom"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        <div className="col-md-3">
                          <Form.Group className="mb-3" controlId="campaign">
                            <Form.Label>Campaign</Form.Label>
                            <Form.Select
                              className="shadow-none focus:!border-theme-dark"
                              name="campaign.cname"
                              onChange={(e) => {
                                setFieldValue('campaign.cname', e.target.value);
                              }}
                              value={values?.campaign?.cname}
                            >
                              <option value="" disabled selected>
                                Select Campaign
                              </option>
                              <option value="Walk-in">Walk-in</option>
                              <option value="Social">Social</option>
                              <option value="News">News</option>
                            </Form.Select>
                            <ErrorMessage
                              name="campaign.cname"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        {values?.campaign?.cname && (
                          <div className="col-md-3">
                            <Form.Group controlId="campaignDetail">
                              <Form.Label>{values?.campaign?.cname} Details</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder={`Enter ${values?.campaign?.cname} details`}
                                className="shadow-none"
                                name="campaign.description"
                                onChange={(e) =>
                                  setFieldValue('campaign.description', e.target.value)
                                }
                                value={values?.campaign?.description}
                              />
                              <ErrorMessage
                                name="campaign.description"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </div>
                        )}


                        <div className="col-md-6">
                          <Form.Group className="mb-6">
                            <Form.Label>Remark</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={5}
                              cols={10}
                              name="remark"
                              onChange={(e) => setFieldValue('remark', e.target.value)}
                              value={values.remark}
                              placeholder="Enter Remark"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="remark"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="text"
                              name="email"
                              as={Form.Control}
                              onChange={(e) => setFieldValue('email', e.target.value)}
                              value={values.email}
                              placeholder="Enter Email"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        {/* Dynamic Form Fields */}
                        {formFields?.getFormFields?.data?.formFields?.fields?.map((field) => (
                          <div key={field._id} className="col-md-3">
                            <Form.Group className="mb-3">
                              <Form.Label>{field.label}</Form.Label>
                              {field.inputType === 'select' ? (
                                <Form.Select
                                  name={`dynamicFields.${field.name}`}
                                  onChange={(e) => setFieldValue(`dynamicFields.${field.name}`, e.target.value)}
                                  value={values.dynamicFields?.[field.name] || ''}
                                  className="shadow-none focus:!border-theme-dark"
                                  required={field.required}
                                >
                                  <option value="">Select {field.label}</option>
                                  {field.options.map((option, index) => (
                                    <option key={index} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </Form.Select>
                              ) : field.inputType === 'checkbox' ? (
                                <div>
                                  {field.options.map((option, index) => (
                                    <Form.Check
                                      key={index}
                                      type="checkbox"
                                      label={option}
                                      name={`dynamicFields.${field.name}`}
                                      onChange={(e) => {
                                        const currentValues = values.dynamicFields?.[field.name] || [];
                                        if (e.target.checked) {
                                          setFieldValue(`dynamicFields.${field.name}`, [...currentValues, option]);
                                        } else {
                                          setFieldValue(
                                            `dynamicFields.${field.name}`,
                                            currentValues.filter((value) => value !== option)
                                          );
                                        }
                                      }}
                                      className="shadow-none"
                                    />
                                  ))}
                                </div>
                              ) : field.inputType === 'radio' ? (
                                <div>
                                  {field.options.map((option, index) => (
                                    <Form.Check
                                      key={index}
                                      type="radio"
                                      label={option}
                                      name={`dynamicFields.${field.name}`}
                                      value={option}
                                      onChange={(e) => setFieldValue(`dynamicFields.${field.name}`, e.target.value)}
                                      className="shadow-none"
                                    />
                                  ))}
                                </div>
                              ) : field.inputType === 'textarea' ? (
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  name={`dynamicFields.${field.name}`}
                                  onChange={(e) => setFieldValue(`dynamicFields.${field.name}`, e.target.value)}
                                  value={values.dynamicFields?.[field.name] || ''}
                                  placeholder={`Enter ${field.label}`}
                                  className="shadow-none focus:!border-theme-dark"
                                  required={field.required}
                                />
                              ) : (
                                <Form.Control
                                  type={field.inputType}
                                  name={`dynamicFields.${field.name}`}
                                  onChange={(e) => setFieldValue(`dynamicFields.${field.name}`, e.target.value)}
                                  value={values.dynamicFields?.[field.name] || ''}
                                  placeholder={`Enter ${field.label}`}
                                  className="shadow-none focus:!border-theme-dark"
                                  required={field.required}
                                />
                              )}
                              <ErrorMessage
                                name={`dynamicFields.${field.name}`}
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </div>
                        ))}
                        <div className="border-t"></div>
                        <h4 className="my-3">Call Time</h4>

                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Next Followup Date</Form.Label>
                            <Form.Control
                              type="date"
                              name="nextFollowUpDate"
                              as={Form.Control}
                              onChange={(e) =>
                                setFieldValue('nextFollowUpDate', e.target.value)
                              }
                              value={values.nextFollowUpDate}
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="nextFollowUpDate"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>From</Form.Label>
                            <Form.Control
                              type="time"
                              name="from"
                              onChange={(e) => setFieldValue('from', e.target.value)}
                              value={values.from}
                              // value={time.from ? time.from.split(' ')[0] : ''}
                              className="shadow-none focus:!border-theme-dark"
                            />{' '}
                            <ErrorMessage
                              name="from"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>To</Form.Label>
                            <Form.Control
                              type="time"
                              name="to"
                              onChange={(e) => setFieldValue('to', e.target.value)}
                              value={values.to}
                              // value={time.to ? time.to.split(' ')[0] : ''}
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="to"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>



                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Lead assign</Form.Label>
                            <div className="relative">
                              <input
                                className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                onClick={() => {
                                  setDoctorData2(!doctorData2);
                                  setSearchType('Manager');
                                }}
                                value={SelectedCounselorName || ''}
                                placeholder={SelectedCounselorName ? SelectedCounselorName : 'Select Counselor'}
                              />

                              <div
                                className={`${doctorData2 ? 'opacity-100 visible' : 'opacity-0 invisible'
                                  } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                              >
                                <input
                                  type="text"
                                  name="search"
                                  value={searchQuery}
                                  placeholder={`Search Manager`}
                                  onChange={searchData}
                                  className="w-full border p-2 rounded outline-none"
                                />
                                {createFile?.allCounselor?.data?.CounselorsData?.map((res) => {
                                  return (
                                    <p
                                      key={res._id}
                                      value={res.name}
                                      onClick={() => {
                                        setSelectedCounselorName(res.name);
                                        selectCounselor(res.name, res._id, setFieldValue); // Pass all parameters
                                      }}
                                      className="text-gray-700 py-1 cursor-pointer"
                                    >
                                      {res.name}
                                    </p>
                                  );
                                })}
                              </div>
                            </div>
                            <ErrorMessage
                              name="counselorAssign"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>


                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Lead FollowUp Remark</Form.Label>
                            <Form.Control
                              type="text"
                              name="leadFollowUpRemark"
                              as={Form.Control}
                              onChange={(e) =>
                                setFieldValue('leadFollowUpRemark', e.target.value)
                              }
                              value={values.leadFollowUpRemark}
                              placeholder="Select Lead FollowUp Remark"
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="leadFollowUpRemark"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Photo</Form.Label>
                            <Form.Control
                              type="file"
                              name="photo"
                              accept="image/*"
                              onChange={(e) => handleFileChange(e, setFieldValue)}
                              className="shadow-none focus:!border-theme-dark"
                            />
                            <ErrorMessage
                              name="photo"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer text-end">
                      <Button
                        variant="secondary"
                        onClick={handleCancel}
                        // onClick={() => navigate('/master/lead')}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color me-2"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="!bg-theme-dark border-0 px-4"
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
         
        </Modal.Body>
      </Modal>


    </>

  );
};

export default AddLead;
